"use client"
import React, {useState} from "react";
import {useTranslations} from "next-intl";
import Image from "next/image";
import Link from "next/link";
import {BASE_URL} from "@/constants";
import toast from "react-hot-toast";

interface Props {
  params: {
    country: string;
  };
}

const ForgotPasswordPage = () => {
  const t = useTranslations('forget_page');

  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const emailInput = e.target.value;
    setEmail(emailInput);
    setIsValidEmail(validateEmail(emailInput));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isValidEmail) {
      const res = await fetch(BASE_URL + "user-auth/forgot-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const data = await res.json()

      if (data.error) {
        return toast.error(data.message);
      }
      setIsSubmitted(true); // Show success message after submitting

    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <Image
        src={'/images/logo/logo-2.png'}
        width={120}
        height={100}
        alt={'Esimafly logo'}
      >

      </Image>
      {!isSubmitted ? (
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
          <h1 className="text-2xl font-semibold text-center mb-4">{t('forgot')}</h1>



          <p className="text-center text-gray-600 mb-6">
            {t('forgot_text')}
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
              className={`w-full p-3 border rounded-lg mb-2 ${
                isValidEmail ? 'border-gray-300' : 'border-red-500'
              }`}
            />

            {!isValidEmail && (
              <p className="text-red-500 text-sm mb-4">{t('email_text')}</p>
            )}

            <button
              type="submit"
              className="mt-4 w-full bg-[#5AC2E7] text-white p-3 rounded-lg"
              disabled={!isValidEmail || !email}
            >
              {t('submit')}
            </button>
          </form>
        </div>
      ) : (
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-green-500 mx-auto mb-6"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.292 9.292l-6.003 6.003a1 1 0 01-1.414 0l-3.002-3.002a1 1 0 111.414-1.414l2.297 2.297 5.296-5.296a1 1 0 011.414 1.414z"
            />
          </svg>

          <h1 className="text-2xl font-semibold mb-4">{t('email_sent')}</h1>
          <p className="text-gray-600 mb-6">
            {t('email_sent_desc',{ email })}
          </p>

          <Link
            href={'/signin'}
            className="block w-full bg-[#5AC2E7] text-white p-3 rounded-lg">
            {t('okay')}
          </Link>
        </div>
      )}
    </div>
  );
}

export default ForgotPasswordPage;